import { Dispatch, SetStateAction, useRef } from "react";
import Modal from "./modal.comp";

export default function ModalWithBtn({
  btnChild,
  children,
  modalOpened,
  setModalOpened,
}: {
  btnChild: React.ReactNode;
  children: React.ReactNode;
  modalOpened: boolean;
  setModalOpened: Dispatch<SetStateAction<boolean>>;
}) {
  const btnRef = useRef<HTMLButtonElement>(null);

  return (
    <>
      <button ref={btnRef} onClick={() => setModalOpened(true)}>
        {btnChild}
      </button>
      {modalOpened && (
        <Modal btnRef={btnRef} setModalOpened={setModalOpened}>
          {children}
        </Modal>
      )}
    </>
  );
}
